module.exports = __webpack_public_path__ + "img/desk4.96647157.png";